import { useSearchParams } from 'react-router-dom-v5-compat'
import useUser from '../../Shared/UserProvider/useUser'
import { useTranslation } from 'react-i18next'
import { OpenTimeSegment } from './OpenTimeSegment'
import { isProviderACompany } from '../../../services/Provider/Provider.service'
import { LoadingPlaceholder } from './HeatMapOpeningTimes/LoadingPlaceholder'
import moment from 'moment/moment'
import { COLOR_SCALE_OVERALL } from './openingTimeHelpers'
import { useEffect, useState } from 'react'
import { useOverallOpeningTimes } from './hooks'

const OverallOpeningTimes = () => {
    const [t] = useTranslation()
    const {user} = useUser()
    const [searchParams] = useSearchParams()
    const [forceRender, setForceRender] = useState(0)
    const from = searchParams.get('from')
    const to = searchParams.get('to')

    const {data: overallOpeningTimes, isLoading} = useOverallOpeningTimes({ from, to, enabled: !!from && !!to })

    useEffect(() => {
        if (overallOpeningTimes) {
            // Hack: the Overall apex chart is displayed a bit shrunken initially, so we force a re-render by dispatching a resize event
            const timer = setTimeout(() => {
                setForceRender(prev => prev + 1)
                window.dispatchEvent(new Event('resize'))
            }, 10)
            return () => clearTimeout(timer)
        }
    }, [overallOpeningTimes])

    if (isLoading) {
        const rowCount = from && to ? moment(to).diff(moment(from), 'days') + 1 : 1
        return <LoadingPlaceholder rowCount={rowCount}/>
    }

    if (!overallOpeningTimes || !overallOpeningTimes?.openings || overallOpeningTimes?.openings?.length === 0) {
        return null
    }

    return (
      <OpenTimeSegment
        key={forceRender}
        title={t('openings.opening_times.average_opening_on_scope ', { scopeName: isProviderACompany(user.provider) ?user.getUserCompany().name : t('openings.opening_times.across_all_your_pos')})}
        openingsTimes={overallOpeningTimes}
        isWeekly
        colorScale={COLOR_SCALE_OVERALL}
      />
    )
}

export { OverallOpeningTimes }
